// Add custom styles for the range inputs
export const rangeStyles = `
.timeline-container {
  position: relative;
  height: 40px;
  width: 100%;
  margin: 20px 0;
  box-sizing: border-box;
}

/* Add styles to prevent text selection */
* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Allow text selection for specific elements that need it */
input, textarea, [contenteditable] {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

/* Prevent text highlighting */
::selection {
  background: transparent;
}
::-moz-selection {
  background: transparent;
}

.timeline-track {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 8px;
  background: #CCCCCC;
  transform: translateY(-50%);
  border-radius: 4px;
  border: 1px solid #3a3a3a;
  box-sizing: border-box;
  cursor: ew-resize;
}

.timeline-track::before {
  content: '↔';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

.timeline-endpoint {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 40px;
  background: none;
  border: none;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #fff;
  font-family: serif;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  pointer-events: auto;
  outline: none;
  box-shadow: none;
}

.timeline-endpoint-label {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  color: #ffffff;
  font-family: serif;
  font-size: 14px;
  margin-bottom: 4px;
  white-space: nowrap;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.timeline-point {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 40px;
  background: none;
  border: none;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #fff;
  font-family: serif;
  font-weight: bold;
  cursor: pointer;
  left: calc(var(--position) * (100% - 24px));
  pointer-events: auto;
  outline: none;
  box-shadow: none;
}

.timeline-point-label {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  color: #ffffff;
  font-family: serif;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  white-space: nowrap;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
  min-width: 40px;
  text-align: center;
  pointer-events: none;
}

.timeline-labels {
  display: flex;
  position: absolute;
  width: 100%;
  top: 100%;
  left: 0;
  color: #ffffff;
  font-family: serif;
  font-size: 14px;
  padding-top: 8px;
  pointer-events: none;
  height: 20px; /* Fixed height for consistent alignment */
}

.timeline-label {
  position: absolute;
  transform: translateX(-50%);
  text-align: center;
  min-width: 40px;
  pointer-events: none;
  line-height: 1; /* Ensure consistent line height */
  white-space: nowrap; /* Prevent wrapping */
}

.timeline-label::before {
  content: '';
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 8px;
  background: #3a3a3a;
}

.timeline-current-years {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  color: #ffffff;
  font-family: serif;
  font-size: 16px;
  font-weight: bold;
}

.timeline-controls {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.timeline-button {
  background: linear-gradient(to bottom, #4a4a4a, #3a3a3a);
  border: 1px solid #2b2b2b;
  padding: 8px 16px;
  color: #ffffff;
  border-radius: 5px;
  cursor: pointer;
  font-family: serif;
  font-size: 14px;
}

.timeline-button:hover {
  background: linear-gradient(to bottom, #5a5a5a, #4a4a4a);
}

.timeline-endpoint:focus,
.timeline-point:focus {
  outline: none !important;
  box-shadow: none !important;
}
`;

export const playPauseStyles = `
  .play-pause-button {
    background: linear-gradient(to bottom, #4a4a4a, #3a3a3a);
    border: 2px solid #2b2b2b;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -50px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgb(86 84 79 / 9%);
  }

  .play-pause-button:hover {
    background: linear-gradient(to bottom, #5a5a5a, #4a4a4a);
    transform: translateX(-50%) scale(1.1);
  }

  .play-pause-button svg {
    width: 20px;
    height: 20px;
    fill: #ffffff;
  }
`;

export const speedControlStyles = `
  .speed-controls {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 16px;
  }

  .speed-button {
    background: linear-gradient(to bottom, #4a4a4a, #3a3a3a);
    border: 1px solid #2b2b2b;
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
  }

  .speed-button:hover {
    background: linear-gradient(to bottom, #5a5a5a, #4a4a4a);
  }

  .speed-display {
    color: white;
    font-family: serif;
    font-size: 14px;
    min-width: 40px;
    text-align: center;
  }
`;